/**
 * Pestañas de guía de tallas: eventos propios (no on:click del tema) para evitar
 * fallos de instanceof Component entre módulos.
 */
export class SizeGuideTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeydown);
    this.#syncTabIndexes();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  /** @returns {HTMLButtonElement[]} */
  get #tabs() {
    return [...this.querySelectorAll('[role="tab"]')].filter(
      (el) => el instanceof HTMLButtonElement
    );
  }

  #syncTabIndexes() {
    for (const tab of this.#tabs) {
      const selected = tab.getAttribute('aria-selected') === 'true';
      tab.tabIndex = selected ? 0 : -1;
    }
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (!tab || !this.contains(tab) || !(tab instanceof HTMLButtonElement)) return;
    this.#setActiveTab(tab);
  };

  /** @param {KeyboardEvent} event */
  #onKeydown = (event) => {
    const key = event.key;
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

    const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (!tab || !this.contains(tab) || !(tab instanceof HTMLButtonElement)) return;

    const tabs = this.#tabs;
    const current = tabs.indexOf(tab);
    if (current < 0) return;

    event.preventDefault();

    let next = current;
    if (key === 'ArrowRight') {
      next = (current + 1) % tabs.length;
    }
    if (key === 'ArrowLeft') {
      next = (current - 1 + tabs.length) % tabs.length;
    }
    if (key === 'Home') {
      next = 0;
    }
    if (key === 'End') {
      next = tabs.length - 1;
    }

    const nextTab = tabs[next];
    if (nextTab) {
      this.#setActiveTab(nextTab);
      nextTab.focus();
    }
  };

  /**
   * @param {HTMLButtonElement} active
   */
  #setActiveTab(active) {
    for (const tab of this.#tabs) {
      const isSelected = tab === active;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.tabIndex = isSelected ? 0 : -1;

      const panelId = tab.getAttribute('aria-controls');
      if (!panelId) continue;

      const panel = document.getElementById(panelId);
      if (!(panel instanceof HTMLElement) || !this.contains(panel)) {
        continue;
      }

      if (isSelected) {
        panel.removeAttribute('hidden');
      } else {
        panel.hidden = true;
      }
    }
  }
}

if (!customElements.get('size-guide-tabs')) {
  customElements.define('size-guide-tabs', SizeGuideTabs);
}
